module.exports = __webpack_public_path__ + "static/media/alis12.f01722d9.jpg";